import axios from "../helper/Axios.js";
import { adminUrl } from "../config/config.js";
import { errorValidation } from "./service.js";

export async function createTournament(body) {
  try {
    console.log(body)
    let scheduleInfo = []
    for (let i = 0; i < body.scheduleInfo.length; i ++) {
      let orderSession = body.scheduleInfo[i].orderSession
      orderSession.map(v => {
        scheduleInfo.push({
          orderSessionId: v,
          date: body.scheduleInfo[i].date,
          hours: body.scheduleInfo[i].courtsInfo.flatMap(court => court.hours).sort((a, b) => a.localeCompare(b))
        })
      })
    }
    const filteredCategories = body.categoriesInfo.filter(item => body.categories.some(obj => obj === item.value));
    body.categoriesInfo = filteredCategories

    if (body.criteria && body.criteria.excludeUser) {
      body.criteria.excludeUser = body.criteria.excludeUser.map(v => v.value)
    }

    if (body.userInCharge) {
      body.userInCharge = body.userInCharge.map(v => v.value)
    }

    let response = await axios.Post({
        url: `${adminUrl}/tournament-create`,
        data: { ...body,
          scheduleInfo,
          criteria: {
            ...body.criteria,
            type: body.orderType.value,
          }
        }
    });

    if (response.statusCode !== 200) { throw response.data; }
    let data = response.data;
    return { data };
  } catch (e) {
    console.log('here e', e)
    // return { error: e.response.data.errorCode }
    return errorValidation(e)
  }
}

export async function updateTournamentInfo(body) {
  try {
    console.log(body)
    let scheduleInfo = []
    for (let i = 0; i < body.scheduleInfo.length; i ++) {
      let orderSession = body.scheduleInfo[i].orderSession
      orderSession.map(v => {
        scheduleInfo.push({
          orderSessionId: v,
          date: body.scheduleInfo[i].date,
          hours: body.scheduleInfo[i].courtsInfo.flatMap(court => court.hours).sort((a, b) => a.localeCompare(b))
        })
      })
    }
    const filteredCategories = body.categoriesInfo.filter(item => body.categories.some(obj => obj === item.value));
    body.categoriesInfo = filteredCategories

    if (body.criteria && body.criteria.excludeUser) {
      body.criteria.excludeUser = body.criteria.excludeUser.map(v => v.value)
    }

    if (body.userInCharge) {
      body.userInCharge = body.userInCharge.map(v => v.value)
    }

    let response = await axios.Post({
        url: `${adminUrl}/tournament-update`,
        data: { ...body,
          scheduleInfo,
          criteria: {
            ...body.criteria,
            type: body.orderType.value,
          }
        }
    });
    
    if (response.statusCode !== 200) { throw response.data; }
    let data = response.data;
    return { data };
  } catch (e) {
    console.log('here e', e)
    // return { error: e.response.data.errorCode }
    return errorValidation(e)
  }
}

export async function getTournaments({}) {
  try {
    let response = await axios.Get({
        url: `${adminUrl}/tournament-list?`,
    });

    if (response.statusCode !== 200) { throw response.data; }
    let data = response.data;
    return { data };
  } catch (e) {
    console.log('here e', e)
    // return { error: e.response.data.errorCode }
    return errorValidation(e)
  }
}

export async function getTournamentDetail({id}) {
  try {
    let response = await axios.Get({
        url: `${adminUrl}/tournament/${id}`,
    });

    if (response.statusCode !== 200) { throw response.data; }
    let data = response.data;
    return { data };
  } catch (error) {
    return { error }
  }
}

export async function getTournamentCategoryLevel({ id, categoryId }) {
  try {
    let response = await axios.Get({
        url: `${adminUrl}/tournament-category-level/${id}?categoryId=${categoryId}`,
    });
    if (response.statusCode !== 200) { throw response.data; }
    let data = response.data;
    return { data };
  } catch (error) {
    return { error }
  }
}

export async function getTournamentParticipant({ id, categoryId, levelId }) {
  try {
    let response = await axios.Get({
        url: `${adminUrl}/tournament-participant/${id}?categoryId=${categoryId}&levelId=${levelId}`,
    });

    if (response.statusCode !== 200) { throw response.data; }
    let data = response.data;
    return { data };
  } catch (e) {
    console.log('here e', e)
    // return { error: e.response.data.errorCode }
    return errorValidation(e)
  }
}

export async function updateVerificationInfo ({id, idName}) {
  try {
    let response = await axios.Post({
        url: `${adminUrl}/player/update-verification-info/${id}`,
        data: { 
          idName
        }
    });

    if (response.statusCode !== 200) { throw response.data; }
    let data = response.data;
    return { data };
  } catch (e) {
    console.log('here e', e)
    // return { error: e.response.data.errorCode }
    return errorValidation(e)
  }
}

export async function getTournamentApplicant({ id }) {
  try {
    let response = await axios.Get({
        url: `${adminUrl}/tournament-applicant/${id}`,
    });

    if (response.statusCode !== 200) { throw response.data; }
    let data = response.data;
    return { data };
  } catch (error) {
    return { error }
  }
}

export async function updateRegistrationStatus ({ _id, status }) {
  try {
    let response = await axios.Post({
        url: `${adminUrl}/tournament-applicant-update`,
        data: { _id, status }
    });
    if (response.statusCode !== 200) { throw response.data; }
    let data = response.data;
    return { data };
  } catch (e) {
    return errorValidation(e)
  }
}

export async function getTournamentCategory() {
  try {
    let response = await axios.Get({
        url: `${adminUrl}/tournament-category-list`,
    });

    if (response.statusCode !== 200) { throw response.data; }
    let data = response.data;
    return { data };
  } catch (e) {
    console.log('here e', e)
    // return { error: e.response.data.errorCode }
    return errorValidation(e)
  }
}

export async function getTournamentFormat() {
try {
    let response = await axios.Get({
        url: `${adminUrl}/tournament-format-list`,
    });

    if (response.statusCode !== 200) { throw response.data; }
    let data = response.data;
    return { data };
  } catch (e) {
    console.log('here e', e)
    // return { error: e.response.data.errorCode }
    return errorValidation(e)
  }
}

export async function getTournamentLevel() {
  try {
    let response = await axios.Get({
        url: `${adminUrl}/tournament-level-list`,
    });

    if (response.statusCode !== 200) { throw response.data; }
    let data = response.data;
    return { data };
  } catch (e) {
    console.log('here e', e)
    // return { error: e.response.data.errorCode }
    return errorValidation(e)
  }
}

export async function getApplicantVerification(userId) {
  try {
    let response = await axios.Get({
        url: `${adminUrl}/tournament-verification-list?userId=${userId}`,
    });

    if (response.statusCode !== 200) { throw response.data; }
    let data = response.data;
    return { data };
  } catch (e) {
    console.log('here e', e)
    // return { error: e.response.data.errorCode }
    return errorValidation(e)
  }
}

export async function getTournamentParticipantPoolBracket ({
  tournamentId, tournamentDetailCategoryId, levelId
}) {
  try {
    let response = await axios.Get({
        url: `${adminUrl}/tournament-participants?tournamentId=${tournamentId}&tournamentDetailCategoryId=${tournamentDetailCategoryId}&levelId=${levelId}`,
    });

    if (response.statusCode !== 200) { throw response.data; }
    let data = response.data;
    return { data };
  } catch (error) {
    return errorValidation(error)
  }
}

export async function generateTournament ({
  tournamentId, tournamentDetailCategoryId
}) {
  try {
    let response = await axios.Get({
        url: `${adminUrl}/tournament-generate/${tournamentId}?tournamentDetailCategoryId=${tournamentDetailCategoryId}`,
    });

    if (response.statusCode !== 200) { throw response.data; }
    let data = response.data;
    return { data };
  } catch (e) {
    console.log('here e', e)
    // return { error: e.response.data.errorCode }
    return errorValidation(e)
  }
}

export async function getTournamentPool ({
  tournamentId,
  tournamentDetailCategoryId,
  levelId
}) {
  // http://localhost:5100/admin/tournament-pool-list/68c28a533b63518c9a2996db?tournamentDetailCategoryId=68da331bd114fc04253d7d4d
  try {
    let response = await axios.Get({
        url: `${adminUrl}/tournament-pool-list/${tournamentId}?tournamentDetailCategoryId=${tournamentDetailCategoryId}&levelId=${levelId}`,
    });

    if (response.statusCode !== 200) { throw response.data; }
    let data = response.data;
    return { data };
  } catch (e) {
    console.log('here e', e)
    // return { error: e.response.data.errorCode }
    return errorValidation(e)
  }
}

export async function poolAssign ({
  poolSeedId, participantId
}) {
  try {
    let response = await axios.Post({
        url: `${adminUrl}/tournament-pool-assign`,
        data: { 
          poolSeedId, participantId
        }
    });

    if (response.statusCode !== 200) { throw response.data; }
    let data = response.data;
    return { data };
  } catch (e) {
    console.log('here e', e)
    // return { error: e.response.data.errorCode }
    return errorValidation(e)
  }
}

export async function getTournamentBracket ({
  tournamentId,
  tournamentDetailCategoryId,
  levelId
}) {
  // http://localhost:5100/admin/tournament-pool-list/68c28a533b63518c9a2996db?tournamentDetailCategoryId=68da331bd114fc04253d7d4d
  try {
    let response = await axios.Get({
        url: `${adminUrl}/tournament-bracket-list/${tournamentId}?tournamentDetailCategoryId=${tournamentDetailCategoryId}&levelId=${levelId}`,
    });

    if (response.statusCode !== 200) { throw response.data; }
    let data = response.data;
    return { data };
  } catch (e) {
    console.log('here e', e)
    // return { error: e.response.data.errorCode }
    return errorValidation(e)
  }
}

export async function bracketAssign ({
  bracketSeedId, participantId
}) {
  try {
    let response = await axios.Post({
        url: `${adminUrl}/tournament-bracket-assign`,
        data: { 
          bracketSeedId, participantId
        }
    });

    if (response.statusCode !== 200) { throw response.data; }
    let data = response.data;
    return { data };
  } catch (e) {
    console.log('here e', e)
    // return { error: e.response.data.errorCode }
    return errorValidation(e)
  }
}

export async function getTournamentMatches ({
  tournamentId
}) {
  try {
    let response = await axios.Get({
        url: `${adminUrl}/tournament-matches-schedule/${tournamentId}`,
    });
    if (response.statusCode !== 200) { throw response.data; }
    let data = response.data;
    return { data };
  } catch (e) {
    return errorValidation(e)
  }
}

export async function setMatchSchedule ({
  tournamentId, matches, date, courtId, hour, court
}) {
  try {
    let response = await axios.Patch({
        url: `${adminUrl}/tournament-matches-schedule-set/${tournamentId}`,
        data: { date, courtId, hour, matches, court }
    });
    if (response.statusCode !== 200) { throw response.data; }
    let data = response.data;
    return { data };
  } catch (e) {
    return errorValidation(e)
  }
}

export async function deleteMatchSchedule ({
  matchId
}) {
  try {
    let response = await axios.Patch({
        url: `${adminUrl}/tournament-matches-schedule-remove/${matchId}`
    });
    if (response.statusCode !== 200) { throw response.data; }
    let data = response.data;
    return { data };
  } catch (e) {
    return errorValidation(e)
  }
}

export async function updateScheduleIndexService ({
  body
}) {
  try {
    let response = await axios.Post({
        url: `${adminUrl}/tournament-matches-schedule-index/`,
        data: body
    });
    if (response.statusCode !== 200) { throw response.data; }
    let data = response.data;
    return { data };
  } catch (e) {
    return errorValidation(e)
  }
}

export async function getTournamentInfo ({
  tournamentId
}) {
  try {
    let response = await axios.Get({
        url: `${adminUrl}/tournament-court/${tournamentId}`
    });
    if (response.statusCode !== 200) { throw response.data; }
    let data = response.data;
    return { data };
  } catch (e) {
    return errorValidation(e)
  }
}

export const getWebTournamentPool = async function ({
  tournamentId, tournamentDetailCategoryId
}) {
  try {
    let response = await axios.Get({
        url: `${adminUrl}/tournament-category-pool?tournamentId=${tournamentId}&tournamentDetailCategoryId=${tournamentDetailCategoryId}`
    });
    if (response.statusCode !== 200) { throw response.data; }
    let data = response.data;
    return { data };
  } catch (e) {
    // return { error: e.response.data.errorCode };
    return errorValidation(e)
  }
}

export const getWebTournamentBracket = async function ({
  tournamentId, tournamentDetailCategoryId
}) {
  try {
    let response = await axios.Get({
        url: `${adminUrl}/tournament-category-bracket?tournamentId=${tournamentId}&tournamentDetailCategoryId=${tournamentDetailCategoryId}`
    });
    if (response.statusCode !== 200) { throw response.data; }
    let data = response.data;
    return { data };
  } catch (e) {
    // return { error: e.response.data.errorCode };
    return errorValidation(e)
  }
}

export const getWebTournamentBestOf = async function ({
  tournamentId, tournamentDetailCategoryId
}) {
  try {
    let response = axios.Get({
        url: `${adminUrl}/tournament-category-bestof?tournamentId=${tournamentId}&tournamentDetailCategoryId=${tournamentDetailCategoryId}`
    })
    if (response.statusCode !== 200) { throw response.data; }
    let data = response.data;
    return { data };
  } catch (e) {
    // return { error: e.response.data.errorCode };
    return errorValidation(e)
  }
}

export const getTournamentCourt = async function ({
  tournamentId
}) {
  try {
    let response = await axios.Get({url: `${adminUrl}/tournament-court/${tournamentId}`});
    if (response.statusCode !== 200) { throw response.data; }
    let data = response.data;
    return { data };
  } catch (e) {
    return errorValidation(e)
  }
}


export const setMatchInfoService = async function ({
  matchId, court, date, hours
}) {
  try {
    let response = await axios.Patch({
      url: `${adminUrl}/match/${matchId}/set-info`, 
      data: { 
        court: court || null,
        date: date || null,
        hours: hours || [],
      }});
    if (response.statusCode !== 200) { throw response.data; }
    let data = response.data;
    return { data };
  } catch (error) {
    console.log('here error', error)
  }
}